import { useMemo } from 'react';
import { useApplicationStore } from 'modules/application/store';

export const useTooltipWidth = () => {
  const isMobile = useApplicationStore((state) => state.isMobile);

  return useMemo(() => (isMobile ? 200 : 350), [isMobile]);
};
